export default {
      id: "add_a_photo-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#add_a_photo",
      toString: function () {
        return this.url;
      }
    }